import Tooltip from '@mui/material/Tooltip';
import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClone,
    faPencilAlt
} from "@fortawesome/free-solid-svg-icons";
function MeasurementsModal({ measurements, setMeasurements, handleSubmitMeasurements, setAlertMessage, openAlertPopup, visibleVideoDimensions, showCroppedVideo, enableROI,selecteROIindex,selectedEditableROIindex,roiList }) {
    const [isEditing, setIsEditing] = useState(false);
    const [textareaValue, setTextareaValue] = useState('');
    const [finalTextareaValue, setFinalTextareaValue] = useState('');

    const handleEditClick = () => {
        setTextareaValue(`${measurements.x},${measurements.y},${measurements.width},${measurements.height}`);
        setFinalTextareaValue(`${measurements.x},${measurements.y},${measurements.width},${measurements.height}`);
        setIsEditing(true);
    };

    const handleTextareaChange = (e) => {
        const newValue = e.target.value;

        // Check if there are more than 3 commas
        const commaCount = (newValue.match(/,/g) || []).length;
        if (commaCount > 3) {
            setAlertMessage({
                Errortype: "Error",
                title: "Error",
                message: "Maximum 4 values allowed",
            });
            openAlertPopup();
            return;
        }

        // Only allow numbers and commas
        const regex = /^[0-9,]*$/;
        if (regex.test(newValue)) {
            setTextareaValue(newValue);
        } else {
            setAlertMessage({
                Errortype: "Error",
                title: "Error",
                message: "Invalid input format",
            });
            openAlertPopup();
        }
    };

    const handleCopyClick = () => {
        navigator.clipboard.writeText(`${measurements.x},${measurements.y},${measurements.width},${measurements.height}`);
        setAlertMessage({
            Errortype: "Info",
            title: "Copied!!!",
            message: "Measurements are copied",
        });
        openAlertPopup();
    };

    const handleSaveClick = () => {
        const [x, y, width, height] = textareaValue.split(",").map(Number);
        if (width == 0 || height == 0) {
            setAlertMessage({
                Errortype: "Error",
                title: "Error",
                message: "Invalid input format",
            });
            openAlertPopup();
        } else {
            if (x < 0 || y < 0 || width < 0 || height < 0) {
                setTextareaValue(`${measurements.x}, ${measurements.y}, ${measurements.width}, ${measurements.height}`)
                setAlertMessage({
                    Errortype: "Error",
                    title: "Error",
                    message: "Values cannot be negative.",
                });
                openAlertPopup()
                return;
            }

            if (x + width > visibleVideoDimensions.videoWidth || y + height > visibleVideoDimensions.videoheight) {
                setTextareaValue(`${measurements.x}, ${measurements.y}, ${measurements.width}, ${measurements.height}`);
                setAlertMessage({
                    Errortype: "Error",
                    title: "Error",
                    message: `The rectangle exceeds ${visibleVideoDimensions.videoWidth}x${visibleVideoDimensions.videoheight}.`,
                });
                openAlertPopup()
                return;
            }
            setFinalTextareaValue(`${x},${y},${width},${height}`);
            setMeasurements({
                x, y, width, height,
                editable: true
            });
            handleSubmitMeasurements({
                x, y, width, height
            });
            setIsEditing(false);
        }
    };

    const handleCloseClick = () => {
        setIsEditing(false);
    };

    return (
        <div className="container">
            <div className="heading">
                <h2>ROI {selectedEditableROIindex>0 ? roiList[selectedEditableROIindex]?.roi_id : selecteROIindex>0 ? roiList[selecteROIindex]?.roi_id : ''} Measurements
                    <Tooltip title={"Applicable Only for Full Video"}
                        disableHoverListener={measurements.editable || showCroppedVideo}
                        placement="top"
                        arrow>
                        {
                            enableROI && <button disabled={!(measurements.editable) || showCroppedVideo} onClick={handleEditClick} className="editButton" style={{ color: 'black' }}>
                                <FontAwesomeIcon icon={faPencilAlt} />
                            </button>
                        }
                    </Tooltip>
                </h2>

                {!isEditing && <button onClick={handleCopyClick} className="copyButton">
                    <FontAwesomeIcon icon={faClone} /> Copy
                </button>}
            </div>

            {isEditing ? (
                // Display textarea and buttons when in edit mode
                <div className="textareaContainer">
                    <textarea
                        value={textareaValue}
                        onChange={handleTextareaChange}
                        rows="3"
                        className="textarea"
                    ></textarea>
                    <div className="buttonContainer">
                        <button onClick={handleSaveClick} className="saveButton">
                            Save
                        </button>
                        <button onClick={handleCloseClick} className="closeButton">
                            Close
                        </button>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="row">
                        <div className="fieldBox">X: {measurements.x}</div>
                        <div className="fieldBox">Y: {measurements.y}</div>
                    </div>
                    <div className="row">
                        <div className="fieldBox">Width: {measurements.width}</div>
                        <div className="fieldBox">Height: {measurements.height}</div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MeasurementsModal;
